// @ts-check
import React from 'react';

import CoolifyIcon from '@liquidweb-dev/undercurrent/icons/platform/Coolify';
import DockerIcon from '@liquidweb-dev/undercurrent/icons/platform/Docker';
import DrupalIcon from '@liquidweb-dev/undercurrent/icons/platform/Drupal';
import MagentoIcon from '@liquidweb-dev/undercurrent/icons/platform/Magento';
import PterodactylIcon from '@liquidweb-dev/undercurrent/icons/platform/Pterodactyl';
import WordPressIcon from '@liquidweb-dev/undercurrent/icons/platform/WordPress';

/** @param {import('@liquidweb-dev/undercurrent/types/svgTypes').FixedColorSvgProps & { application?: string }} props */
const ApplicationIcon = ({ application, ...rest }) => {
	const applicationLowerCase = application?.toLowerCase();

	if (applicationLowerCase?.includes('coolify')) {
		return <CoolifyIcon {...rest} />;
	}

	if (applicationLowerCase?.includes('docker')) {
		return <DockerIcon {...rest} />;
	}

	if (applicationLowerCase?.includes('drupal')) {
		return <DrupalIcon {...rest} />;
	}

	if (applicationLowerCase?.includes('magento')) {
		return <MagentoIcon {...rest} />;
	}

	if (applicationLowerCase?.includes('pterodactyl')) {
		return <PterodactylIcon {...rest} />;
	}

	if (applicationLowerCase?.includes('wordpress')) {
		return <WordPressIcon {...rest} />;
	}

	return null;
};

export default ApplicationIcon;
